<template>
  <div class="case-content">
    <div class="container">
      <div class="intro-tekst">
        <slot name="intro-tekst"></slot>
      </div>
      <div class="case-img">
        <slot name="case-img"></slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'titel',
}
</script>

<style lang="scss" scoped>

.intro-tekst{
  h2{
    text-align: center;
  }
  p{
    max-width: 680px;
    margin: 0 auto;
    display: block;
    text-align: center;
  }
}
.case-img{
  img{
    width: 100%;
    max-height: 200px;
  }
}

</style>